import React, { useState } from "react";
import { useLanguage } from "../../hooks/useLanguage";
import MenuSection from "./MenuSection";
import { menuItems } from "../../data/menuItem";
import FadeInSection from "../animations/FadeInSection";
import { motion } from "framer-motion";

const menuCategories = [
  "tapas",
  "starters",
  "salads",
  "mains",
  "desserts",
  "drinks",
];

export default function Menu() {
  const { t, language } = useLanguage();
  const [activeTab, setActiveTab] = useState("tapas");

  return (
    <section
      id="menu"
      className="py-24 bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800"
    >
      {/* Fully booked banner */}
      {/* Removed the fully booked message */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeInSection>
          <h2 className="text-5xl font-extrabold text-center mb-8 gradient-text">
            {t("menu.title")}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-primary to-secondary mx-auto mb-12 rounded-full"></div>
        </FadeInSection>

        {/* Special Menu */}
        <div className="flex flex-col mb-12 bg-white/80 dark:bg-[var(--color-bg-card)] p-8 rounded-2xl shadow-xl backdrop-blur-sm border border-gray-100 dark:border-gray-700">
          <div className="mb-6">
            <h3 className="text-3xl font-bold mb-6 text-primary dark:text-[var(--color-primary)] border-b-2 border-accent pb-2 inline-block">
              Special Menu
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="p-6 bg-white/40 dark:bg-gray-800/40 rounded-xl shadow-md hover-lift border border-gray-100 dark:border-gray-700">
                <h4 className="text-xl font-semibold mb-3 text-gray-900 dark:text-[var(--color-text-base)]">
                  MENU 1 – 35€
                </h4>
                <p className="mb-2 text-gray-700 dark:text-[var(--color-text-muted)]">
                  1. Grilled Tiger Prawns
                </p>
                <p className="mb-2 text-gray-700 dark:text-[var(--color-text-muted)]">
                  2. Grilled Salmon
                </p>
                <p className="text-gray-700 dark:text-[var(--color-text-muted)]">
                  3. Crème Brûlée
                </p>
              </div>

              <div className="p-6 bg-white/40 dark:bg-gray-800/40 rounded-xl shadow-md hover-lift border border-gray-100 dark:border-gray-700">
                <h4 className="text-xl font-semibold mb-3 text-gray-900 dark:text-[var(--color-text-base)]">
                  MENU 2 – 40€
                </h4>
                <p className="mb-2 text-gray-700 dark:text-[var(--color-text-muted)]">
                  1. Bacalhau Croquettes
                </p>
                <p className="mb-2 text-gray-700 dark:text-[var(--color-text-muted)]">
                  2. Grilled Octopus
                </p>
                <p className="text-gray-700 dark:text-[var(--color-text-muted)]">
                  3. Ice Cream
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs Navigation */}
        <div className="flex flex-col sm:flex-row justify-center items-center mb-8 gap-3 sm:gap-4">
          {menuCategories.map((category) => (
            <motion.button
              key={category}
              className={`px-6 py-3 w-full sm:w-auto text-center rounded-full font-semibold transition-all duration-300 ${
                activeTab === category
                  ? "bg-gradient-to-r from-primary to-secondary text-white shadow-lg"
                  : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"
              }`}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => {
                setActiveTab(category);
                const menuSection = document.getElementById(`menu-${category}`);
                if (menuSection) {
                  menuSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }
              }}
            >
              {t(`menu.${category}`)}
            </motion.button>
          ))}
        </div>

        {/* Dietary Information */}
        <div className="text-sm text-center text-gray-600 dark:text-gray-400 mb-10 italic glass-card p-4 rounded-xl">
          (L) Lactose-free | (G) Gluten-free | (V) Vegan | (M) Dairy-free | (N)
          Nut-free | (S) Contains shellfish
        </div>

        {/* Menu Content */}
        <FadeInSection>
          <div id={`menu-${activeTab}`}>
            <MenuSection
              title={t(`menu.${activeTab}`)}
              items={menuItems[activeTab]}
            />
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
